import "./widgets-core14.css";
import { defineComponent as n, useCssVars as s, onMounted as i, openBlock as r, createElementBlock as c, normalizeClass as p, createElementVNode as m, renderSlot as u } from "vue";
import { u as d } from "./chunks/index.DKoe20UO.js";
import { _ } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
const f = { class: "collapse__inner" }, v = /* @__PURE__ */ n({
  __name: "Collapse",
  props: {
    modelValue: { type: Boolean, default: !1 },
    animationDuration: { default: "0.5s" },
    direction: { default: "vertical" },
    autoOpen: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(a, { emit: t }) {
    s((o) => ({
      "2a849078": e.animationDuration
    }));
    const e = a, l = t;
    return i(() => {
      e.autoOpen && d(() => {
        l("update:modelValue", !0);
      }, 0);
    }), (o, V) => (r(), c("div", {
      class: p([
        "collapse__main",
        e.direction === "vertical" ? "collapse__main--vertical" : "collapse__main--horizontal",
        { "collapse__main--open": e.modelValue }
      ])
    }, [
      m("div", f, [
        u(o.$slots, "default", {}, void 0, !0)
      ])
    ], 2));
  }
}), k = /* @__PURE__ */ _(v, [["__scopeId", "data-v-0e2dfc19"]]);
export {
  k as default
};
//# sourceMappingURL=widgets-core.es16.js.map
